import { TICK_RATE } from "@meleeroyale/sim";

export function clockFromTicks(ticks: number): string {
  const total = Math.max(0, Math.ceil(ticks / TICK_RATE));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
}

export function secondsFromTicks(ticks: number): number {
  return Math.max(0, Math.ceil(ticks / TICK_RATE));
}

export function percent(value: number, max: number): number {
  return max > 0 ? Math.max(0, Math.min(100, (value / max) * 100)) : 0;
}

/** m:ss for a count of seconds. */
export function clockFromSeconds(seconds: number): string {
  const total = Math.max(0, Math.ceil(seconds));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
}

const percentFormat = new Intl.NumberFormat("en", { style: "percent", maximumFractionDigits: 0 });

/** 0.7 → "70%". */
export function formatPercent(fraction: number): string {
  return percentFormat.format(fraction);
}
